import {
  AdminPanelSettings,
  AirplaneTicket,
  Business as BusinessIcon,
  Campaign,
  Casino,
  CardGiftcard,
  Home as HomeIcon,
  LanguageRounded,
  LiveHelpRounded,
  LocationSearchingOutlined,
  Login as LoginIcon,
  MiscellaneousServices,
  MonetizationOn,
  Place,
  Settings,
  SettingsApplicationsRounded,
  SupervisedUserCircle as UsersIcon,
  QrCode2,
} from "@mui/icons-material"
import { BrowserRouter, Navigate, Route, Routes as RoutesBase } from "react-router-dom"
import { BusinessDetail, BusinessesComponent } from "./BusinessesComponent"
import { useEffect, useState } from "react";
import { AdsComponent } from "./components/ads/AdsComponent"
import { LocationsComponent } from "./components/locations/LocationsComponent"
import { StandaloneServicesComponent } from "./components/services/StandaloneServicesComponent"

import AdminCouponCampaignsPage from "./components/CouponCampaigns/AdminCouponCampaignsPage"
import AdminNotificationsPage from "./components/Notification/AdminNotificationsPage"
import AdminPanelConfig from "./components/AdminPanelConfig"
import { DisplayContentConfig } from "./components/Configuration/DisplayContentConfig";
// import EditSponsor from "./components/EditSponsor"
import ErrorPage from "./error-page"
import Home from "./components/Home"
import Login from "./components/Login"
import LoginsScreen from "./components/LoginScreen"
// import Notification from "./components/Notification"
import Onboarding from "./components/Onboarding"
import RaffleDetail from "./components/raffle/RaffleDetail"
import RaffleEdit from "./components/raffle/RaffleEdit"
import RaffleTickets from "./components/raffle/RaffleTickets"
import Raffles from "./components/raffle/Raffles"
import ReceiptContentExtractor from "./components/ReceiptContentExtractor"
import Root from "./root"
import SponsorTabs from "./components/SponsorTabs"
import Sponsors from "./components/Sponsors"
import Tickets from "./components/Tickets"
import Translations from "./components/Translations"
import UserAdminPage from "./components/Users/UserAdminPage"
import Users from "./components/Users"
import VideoIcon from "@mui/icons-material/SwitchVideo"
import VideoManager from "./components/Video/VideoManager"
import ContentManager from "./components/Content/ContentManager"
import FolderIcon from "@mui/icons-material/Folder"
import { WheelConfig } from "./components/wheel/WheelConfig"
import { WheelList } from "./components/wheel/WheelList"
import { auth } from "./firebase"
import i18n from "./i18n"
import { useAuthState } from "react-firebase-hooks/auth"
import CountryTabs from "./components/Countries/CountryTabs"
import VideoPlayer from 'react-ui-components/components/Video/VideoPlayer'
import React from "react";
import { LoadingService, Loading } from "react-ui-components/components/LoadingService";
import { PopupService } from "react-ui-components/components/PopupService";
import FeaturedBusinesses from "./components/FeaturedBusinesses";
import FeaturedBusinessTabs from "./components/FeaturedBusinessTabs";
import ErrorBoundary from "react-ui-components/components/ErrorBoundary";
import UserQRAdmin from "./components/UserQR/UserQRAdmin"

/**
 * Application route configuration array
 * Defines all available routes with their metadata, components, and access control
 */
export const routes = [
  // Public routes (no authentication required)
  { name: "", title: "Home", icon: <HomeIcon />, element: <Home />, auth: false },
  { name: "login", title: "Login", icon: <LoginIcon />, element: <Login />, auth: false },

  // User management routes
  { name: "users", title: "Users", icon: <UsersIcon />, element: (
    <ErrorBoundary
      level="section"
      title="Users Management Error"
      onError={(error, errorInfo) => {
        console.error('Users Management Error:', error, errorInfo);
        PopupService.pushPopup('An error occurred in the Users section. Please try refreshing the page.');
      }}
    >
      <Users />
    </ErrorBoundary>
  ), auth: true },
  {
    name: "notifications",
    title: "Users Notifications",
    icon: <UsersIcon />,
    element: <AdminNotificationsPage />,
    auth: true,
  },
  {
    name: "coupon-campaigns",
    title: "Coupon Campaigns",
    icon: <CardGiftcard />,
    element: (
      <ErrorBoundary
        level="section"
        title="Coupon Campaigns Error"
        onError={(error, errorInfo) => {
          console.error('Coupon Campaigns Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Coupon Campaigns section. Please try refreshing the page.');
        }}
      >
        <AdminCouponCampaignsPage />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "users/:id",
    title: "User",
    icon: <UsersIcon />,
    element: <UserAdminPage />,
    auth: true,
    hidden: true, // Hidden from navigation menu
  },

  // UserQR form and response management
  {
    name: "userqr",
    title: "UserQR",
    icon: <QrCode2 />,
    element: (
      <ErrorBoundary
        level="section"
        title="UserQR Management Error"
        onError={(error, errorInfo) => {
          console.error('UserQR Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in UserQR. Please try refreshing the page.');
        }}
      >
        <UserQRAdmin />
      </ErrorBoundary>
    ),
    auth: true,
  },

  // Ticket management routes
  {
    name: "tickets",
    title: "Tickets",
    icon: <MonetizationOn />,
    element: <Tickets />,
    auth: true,
  },

  // Configuration and content routes
  {
    name: "countries",
    title: "Countries",
    icon: <LocationSearchingOutlined />,
    element: <CountryTabs />,
    auth: true,
  },
  {
    name: "translations",
    title: "Translations",
    icon: <LanguageRounded />,
    element: (
      <ErrorBoundary
        level="section"
        title="Translations Management Error"
        onError={(error, errorInfo) => {
          console.error('Translations Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Translations section. Please try refreshing the page.');
        }}
      >
        <Translations />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "onboarding",
    title: "Onboarding",
    icon: <LiveHelpRounded />,
    element: <Onboarding />,
    auth: true,
  },

  // Application configuration routes
  {
    name: "login-screen-config",
    title: "Login Screen",
    icon: <SettingsApplicationsRounded />,
    element: <LoginsScreen />,
    auth: true,
  },
  {
    name: "receipt-content-extractor",
    title: "Receipt Content Extractor",
    icon: <SettingsApplicationsRounded />,
    element: <ReceiptContentExtractor />,
    auth: true,
  },

  // Raffle management routes
  { name: "raffles", title: "Raffles", icon: <AirplaneTicket />, element: (
    <ErrorBoundary
      level="section"
      title="Raffles Management Error"
      onError={(error, errorInfo) => {
        console.error('Raffles Management Error:', error, errorInfo);
        PopupService.pushPopup('An error occurred in the Raffles section. Please try refreshing the page.');
      }}
    >
      <Raffles />
    </ErrorBoundary>
  ), auth: true },
  {
    name: "raffles/:id",
    title: "ViewRaffle",
    icon: <AirplaneTicket />,
    element: (
      <ErrorBoundary
        level="component"
        title="Raffle Details Error"
        onError={(error, errorInfo) => {
          console.error('Raffle Details Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred loading raffle details. Please try again.');
        }}
      >
        <RaffleDetail />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },
  {
    name: "raffles/edit/:id",
    title: "EditRaffles",
    icon: <AirplaneTicket />,
    element: (
      <ErrorBoundary
        level="component"
        title="Raffle Edit Error"
        onError={(error, errorInfo) => {
          console.error('Raffle Edit Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred loading raffle edit form. Please try again.');
        }}
      >
        <RaffleEdit />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },
  {
    name: "raffles/:id/generate-tickets",
    icon: <AirplaneTicket />,
    element: (
      <ErrorBoundary
        level="component"
        title="Ticket Generation Error"
        onError={(error, errorInfo) => {
          console.error('Ticket Generation Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in ticket generation. Please try again.');
        }}
      >
        <RaffleTickets />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },
  {
    name: "generate/:id",
    icon: <AirplaneTicket />,
    element: <RaffleTickets />,
    auth: true,
    hidden: true,
  },

  // Business management routes
  {
    name: "businesses",
    title: "Businesses",
    icon: <BusinessIcon />,
    element: (
      <ErrorBoundary
        level="section"
        title="Businesses Management Error"
        onError={(error, errorInfo) => {
          console.error('Businesses Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Businesses section. Please try refreshing the page.');
        }}
      >
        <BusinessesComponent />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: false,
  },
  {
    name: "businesses/:id",
    title: "Businesses Details",
    icon: <BusinessIcon />,
    element: (
      <ErrorBoundary
        level="component"
        title="Business Details Error"
        onError={(error, errorInfo) => {
          console.error('Business Details Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred loading business details. Please try again.');
        }}
      >
        <BusinessDetail />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },

  // Locations management route
  {
    name: "locations",
    title: "Locations",
    icon: <Place />,
    element: (
      <ErrorBoundary
        level="section"
        title="Locations Management Error"
        onError={(error, errorInfo) => {
          console.error('Locations Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Locations section. Please try refreshing the page.');
        }}
      >
        <LocationsComponent />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: false,
  },

  // Global Ads management route
  {
    name: "global-ads",
    title: "Ads",
    icon: <Campaign />,
    element: (
      <ErrorBoundary
        level="section"
        title="Ads Management Error"
        onError={(error, errorInfo) => {
          console.error('Ads Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Ads section. Please try refreshing the page.');
        }}
      >
        <AdsComponent />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: false,
  },

  // Standalone (cross-sponsor) services management route
  {
    name: "all-services",
    title: "Services",
    icon: <MiscellaneousServices />,
    element: (
      <ErrorBoundary
        level="section"
        title="Services Management Error"
        onError={(error, errorInfo) => {
          console.error('Services Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Services section. Please try refreshing the page.');
        }}
      >
        <StandaloneServicesComponent />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: false,
  },

  // Sponsor management routes
  {
    name: "sponsors",
    title: "Sponsors",
    icon: <BusinessIcon />,
    element: (
      <ErrorBoundary
        level="section"
        title="Sponsors Management Error"
        onError={(error, errorInfo) => {
          console.error('Sponsors Management Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Sponsors section. Please try refreshing the page.');
        }}
      >
        <Sponsors />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "sponsors/:id",
    title: "Sponsor",
    icon: <BusinessIcon />,
    element: (
      <ErrorBoundary
        level="component"
        title="Sponsor Details Error"
        onError={(error, errorInfo) => {
          console.error('Sponsor Details Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred loading sponsor details. Please try again.');
        }}
      >
        <SponsorTabs />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },

  // Featured businesses routes
  {
    name: "featured-businesses",
    title: "Featured Businesses",
    icon: <BusinessIcon />,
    element: (
      <ErrorBoundary
        level="section"
        title="Featured Businesses Error"
        onError={(error, errorInfo) => {
          console.error('Featured Businesses Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Featured Businesses section. Please try refreshing the page.');
        }}
      >
        <FeaturedBusinesses />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "featured-businesses/:id",
    title: "Featured Businesses Detail",
    icon: <BusinessIcon />,
    element: (
      <ErrorBoundary
        level="component"
        title="Featured Business Details Error"
        onError={(error, errorInfo) => {
          console.error('Featured Business Details Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred loading featured business details. Please try again.');
        }}
      >
        <FeaturedBusinessTabs />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },

  // Content and media management routes
  {
    name: "pages",
    title: "Pages",
    icon: <AdminPanelSettings />,
    element: (
      <ErrorBoundary
        level="section"
        title="Pages Configuration Error"
        onError={(error, errorInfo) => {
          console.error('Pages Configuration Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Pages configuration. Please try refreshing the page.');
        }}
      >
        <AdminPanelConfig />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "video-manager",
    title: "Videos Manager",
    icon: <VideoIcon />,
    element: (
      <ErrorBoundary
        level="section"
        title="Video Manager Error"
        onError={(error, errorInfo) => {
          console.error('Video Manager Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Video Manager. Please try refreshing the page.');
        }}
      >
        <VideoManager />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "content-manager",
    title: "Content Manager",
    icon: <FolderIcon />,
    element: (
      <ErrorBoundary
        level="section"
        title="Content Manager Error"
        onError={(error, errorInfo) => {
          console.error('Content Manager Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Content Manager. Please try refreshing the page.');
        }}
      >
        <ContentManager />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "video-manager/:videoId",
    title: "Videos Manager",
    icon: <VideoIcon />,
    element: (
      <ErrorBoundary
        level="component"
        title="Video Player Error"
        onError={(error, errorInfo) => {
          console.error('Video Player Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred loading the video player. Please try again.');
        }}
      >
        <VideoPlayer video={null} />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },

  // Display configuration route
  {
    name: "display-content-config",
    title: "Display Content Config",
    icon: <Settings />,
    element: (
      <ErrorBoundary
        level="section"
        title="Display Configuration Error"
        onError={(error, errorInfo) => {
          console.error('Display Configuration Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Display configuration. Please try refreshing the page.');
        }}
      >
        <DisplayContentConfig />
      </ErrorBoundary>
    ),
    auth: true,
  },

  // Daily spin wheel ("La Ruleta Win") configuration routes — a list of location/language
  // scoped wheels, each editable at wheel-config/:id.
  {
    name: "wheel-config",
    title: "Wheel Config",
    icon: <Casino />,
    element: (
      <ErrorBoundary
        level="section"
        title="Wheel Config Error"
        onError={(error, errorInfo) => {
          console.error('Wheel Config Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Wheel Config section. Please try refreshing the page.');
        }}
      >
        <WheelList />
      </ErrorBoundary>
    ),
    auth: true,
  },
  {
    name: "wheel-config/:id",
    title: "Wheel Config",
    element: (
      <ErrorBoundary
        level="section"
        title="Wheel Config Error"
        onError={(error, errorInfo) => {
          console.error('Wheel Config Error:', error, errorInfo);
          PopupService.pushPopup('An error occurred in the Wheel Config section. Please try refreshing the page.');
        }}
      >
        <WheelConfig />
      </ErrorBoundary>
    ),
    auth: true,
    hidden: true,
  },
]

/**
 * Main Routes component that handles application routing and authentication
 * Filters routes based on user authentication status and initializes i18n
 * @returns BrowserRouter with filtered routes based on authentication
 */
export const Routes = () => {
  const [isInitialized, setIsInitialized] = useState(false)
  const [filteredRoutes, setFilteredRoutes] = useState(routes)
  const [user, loading] = useAuthState(auth)

  useEffect(() => {
    // Filter routes based on authentication requirement
    if (!loading) {
      setFilteredRoutes(routes.filter((x) => x.auth === !!user) as any)
    }

    /**
     * Initialize application with i18n and other setup
     */
    const initialize = async () => {
      try {
        LoadingService.setLoading(true)
        await i18n.init()
        setIsInitialized(true)
      } catch (error: any) {
        PopupService.pushPopup(error.message)
      } finally {
        LoadingService.setLoading(false)
      }
    }

    initialize()
  }, [user, loading])

  // Show loading screen while initializing or checking authentication
  if (!isInitialized || loading) {
    return <Loading />
  }

  // return JSON.stringify(filteredRoutes)
  return (
    <div style={{ width: "80vw" }}>
      <BrowserRouter>
        <RoutesBase>
          <Route path="" element={<Root />} errorElement={ErrorPage as any}>
            {filteredRoutes.map((item: any, i) => (
              <Route key={`${item.name}-${i}`} path={item.name} element={item.element} />
            ))}
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </RoutesBase>
      </BrowserRouter>
    </div>
  )
}
